import SettingFrame from "../../../../components/@settings/SettingFrame";
import ListWalletUsers from "../../../../components/@wallets/walletUsers/ListWalletUsers";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function WalletUsersPage() {

    let routeType = routeTypes.admin

    return (
          <SettingFrame
                routeType={routeType}
          >
              <ListWalletUsers
                    routeType={routeType}
              />
          </SettingFrame>
    )
}       